module.exports = __webpack_public_path__ + "static/media/OT1@2x.d9e08f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OT/OT1@2x.png
// module id = 709
// module chunks = 0